import { toTitleCase } from "../../js/utils/titleCase";

export default function Headline({ as: Tag = "h1", children, className = "" }) {
  const content =
    typeof children === "string" || typeof children === "number" ? toTitleCase(children) : children;
  return <Tag className={className}>{content}</Tag>;
}
